import { render, staticRenderFns } from "./update-reason.vue?vue&type=template&id=b454ce82"
import script from "./update-reason.vue?vue&type=script&lang=js"
export * from "./update-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports